import React from "react"
import Link from "next/link"

// ---------------------------------------------------------

import RenderBlocks from "@lib/renderBlocks"

// ---------------------------------------------------------

import Layout from "@layout/index"
import Grid from "@components/grid"

// ---------------------------------------------------------

import { list, link_style } from "./styles.module.scss"

// ---------------------------------------------------------
const LegalLayout = ({ data, children, preview, pageTitle, featuredImage, excerpt }) => {
  const meta = {
    "og:title": pageTitle || data?.title,
    title: pageTitle || data?.title,
    "og:image": featuredImage?.url || data?.featuredImage?.url,
    description: excerpt || data?.excerpt,
    "og:description": excerpt || data?.excerpt
  }

  const clickHandler = () => {
    if (typeof window !== "undefined" && window.Cookiebot) {
      window.Cookiebot.renew()
    }
  }

  return (
    <Layout preview={preview} customMeta={meta}>
      {data?.modulesCollection && RenderBlocks(data.modulesCollection.items)}

      <Grid column={3}>
        <div className={list}>
          <h3>Service Terms and Agreements</h3>
          <ul>
            <li>
              <p>
                <a
                  href="https://assets.ctfassets.net/5vqt5w81x2im/Tb7GqmbO2ghYXUAaB7oBu/0537dc2624334588adfefe1c846afc16/Amperity_Online_Terms_and_Conditions.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  Terms of Service
                </a>
              </p>
            </li>
            <li>
              <p>
                <Link href="/legal/site-terms">Site Terms</Link>
              </p>
            </li>
            <li>
              <p>
                <a
                  href="https://assets.ctfassets.net/5vqt5w81x2im/1WSuRkxou1ouniszGoMO1K/8e8d623b92d1ea2cd2015a54eae233d9/Amperity_-_Customer_DPA__v2_2024-05-06_.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  Data Processing Addendum
                </a>
              </p>
            </li>
            <li>
              <p>
                <a
                  href="https://assets.ctfassets.net/5vqt5w81x2im/53Iw5ErM0r1wG1tctBPHEf/1bfec18f77d72189d3f58dba80f2f27c/MNDA_Amperity_Pre-Signed.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  MNDA
                </a>
              </p>
            </li>
            <li>
              <p>
                <Link href="/amperity-acceptable-use-policy">Acceptable Use Policy</Link>
              </p>
            </li>
            <li>
              <p>
                <Link href="/developmental-terms">Developmental Offerings Terms of Service</Link>
              </p>
            </li>
          </ul>
        </div>
        <div className={list}>
          <h3>Privacy</h3>
          <ul>
            <li>
              <p>
                <a href="https://docs.amperity.com/support/subcontractors.html">
                  Subprocessors and Affiliates
                </a>
              </p>
            </li>
            <li>
              <p>
                <Link href="/legal/privacy-notice">Privacy Notice</Link>
              </p>
            </li>
            <li>
              <p>
                <button onClick={clickHandler} onKeyDown={clickHandler}>
                  <a className={link_style}>Cookie Preferences</a>
                </button>
              </p>
            </li>
            <li>
              <p>
                <Link href="/legal/cookie-declaration">Cookie Declaration</Link>
              </p>
            </li>
          </ul>
        </div>
        <div className={list}>
          <h3>Intellectual Property</h3>
          <ul>
            <li>
              <p>
                <Link href="/intellectual-property">Patent Notice</Link>
              </p>
            </li>
          </ul>
        </div>
      </Grid>
      {children}
    </Layout>
  )
}

export default LegalLayout
